module.exports = __webpack_public_path__ + "static/media/ethlogo.c85b78fb.svg";